import { DoctorProfileForm } from "../../components/DoctorProfile/DoctorProfileForm";

export function DoctorProfile() {
  return <DoctorProfileForm />;
}
